import { useTranslation } from "react-i18next";
import changeLocale from "../../common/changeLocale";
import TM_LOCALE from "../../common/icons/locales/tm.jpg";
import RU_LOCALE from "../../common/icons/locales/ru.jpg";
import EN_LOCALE from "../../common/icons/locales/en.jpg";
import image from "../../common/images/for_home_page.png";

const HomeSection = () => {
  const { t } = useTranslation(["common"]);

  return (
    <>
      <main
        id="home"
        className="area grid grid-cols-12 overflow-hidden pt-16 md:pt-0 md:h-screen "
      >
        <section className=" col-span-12 sm:col-span-6 md:col-span-8 text-gray-700 flex justify-between flex-col px-10">
          <div></div>
          <article className="text-yellow-500 py-20 md:py-0">
            <div className="font-prompt-bold text-5xl xl:text-9xl">
              {t("common:title")}
            </div>
            <div className="font-prompt-regular mt-3 text-2xl xl:text-5xl mr-20">
              {t("common:welcome")}
            </div>
          </article>

          <aside className="flex space-x-4 text-2xl my-4 z-10">
            <button onClick={() => changeLocale("tm")}>
              <img className="w-9" src={TM_LOCALE} alt="tm" />
            </button>

            <button onClick={() => changeLocale("ru")}>
              <img className="w-9" src={RU_LOCALE} alt="ru" />
            </button>

            <button onClick={() => changeLocale("en")}>
              <img className="w-9" src={EN_LOCALE} alt="en" />
            </button>
          </aside>
        </section>

        <section className="relative col-span-12 sm:col-span-6 md:col-span-4 flex items-center  py-20 md:py-0">
          <img
            src={image}
            alt="drink"
            className="xl:max-h-screen md:-translate-x-36 w-48 xl:w-max mx-auto z-10"
          />
        </section>
      </main>
      <ul className="circles">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </>
  );
};

export default HomeSection;
